export const environment = {
    production: false,
    apiUrl: 'https://alphaservice-dev-142966532798.us-central1.run.app/api/v1',
    devApiUrl: 'https://alphaservice-dev-142966532798.us-central1.run.app/api/v1',
    devApiToken: 'API-be270c2fbad55f475ff4eac1cbf39be93529aade7005323c972a579feb3be1a06645df410665a30b'
};
